<template>
  <div style="display: none"></div>
</template>
<style lang="scss" src="./SignalR.scss"></style>
<script lang="ts" src="./SignalR.ts"></script>
